import { createContext } from "react";

import { ManualMeasurementPointSummary } from "@/features/measurements/model/types/MeasurementGroups";

export const MeasurementContext = createContext<{
	selectedMeasurement: ManualMeasurementPointSummary | null;
	groupId: number | null;
	selectMeasurement: (
		measurementPoint: ManualMeasurementPointSummary | null,
	) => void;
	setGroupId: (groupId: number) => void;
}>({
	selectedMeasurement: null,
	groupId: null,
	selectMeasurement: () => {},
	setGroupId: () => {},
});

export const MeasurementProvider = MeasurementContext.Provider;
export const MeasurementConsumer = MeasurementContext.Consumer;
